class InnovationActions {
    static INNOVATION_REQUEST = "INNOVATION_REQUEST";
    static INNOVATION_SUCCESSFUL = "INNOVATION_SUCCESSFUL";
    static INNOVATION_FAILED = "INNOVATION_FAILED";

    static innovationRequest() {
        return {
            type: this.INNOVATION_REQUEST
        };
    }
    static innovationSuccessul(data) {
        return {
            type: this.INNOVATION_SUCCESSFUL,
            data
        };
    }
    static innovationFailed(error) {
        return {
            type: this.INNOVATION_FAILED,
            error
        };
    }

    //********** GET INNOVATION FROM ID ***********
    static GET_INNOVATION_BY_ID_REQUEST = "GET_INNOVATION_BY_ID_REQUEST";
    static GET_INNOVATION_BY_ID_SUCCESSFUL = "GET_INNOVATION_BY_ID_SUCCESSFUL";
    static GET_INNOVATION_BY_ID_FAILED = "GET_INNOVATION_BY_ID_FAILED";

    static getInnovationByIdRequest() {
        return {
            type: this.GET_INNOVATION_BY_ID_REQUEST
        };
    }
    static getInnovationByIdSuccessul(data) {
        return {
            type: this.GET_INNOVATION_BY_ID_SUCCESSFUL,
            data
        };
    }
    static getInnovationByIdFailed(error) {
        return {
            type: this.GET_INNOVATION_BY_ID_FAILED,
            error
        };
    }

    //********** UPDATE INNOVATION ***********
    static UPDATE_INNOVATION_REQUEST = "UPDATE_INNOVATION_REQUEST";
    static UPDATE_INNOVATION_SUCCESSFUL = "UPDATE_INNOVATION_SUCCESSFUL";
    static UPDATE_INNOVATION_FAILED = "UPDATE_INNOVATION_FAILED";

    static updateInnovationRequest() {
        return {
            type: this.UPDATE_INNOVATION_REQUEST
        };
    }
    static updateInnovationSuccessul(data) {
        return {
            type: this.UPDATE_INNOVATION_SUCCESSFUL,
            data
        };
    }
    static updateInnovationFailed(error) {
        return {
            type: this.UPDATE_INNOVATION_FAILED,
            error
        };
    }

    //********** GET INNOVATION LIST ***********
    static GET_INNOVATION_LIST_REQUEST = "GET_INNOVATION_LIST_REQUEST";
    static GET_INNOVATION_LIST_SUCCESSFUL = "GET_INNOVATION_LIST_SUCCESSFUL";
    static GET_INNOVATION_LIST_FAILED = "GET_INNOVATION_LIST_FAILED";

    static getInnovationListRequest() {
        return {
            type: this.GET_INNOVATION_LIST_REQUEST
        };
    }
    static getInnovationListSuccessul(data) {
        return {
            type: this.GET_INNOVATION_LIST_SUCCESSFUL,
            data
        };
    }
    static getInnovationListFailed(error) {
        return {
            type: this.GET_INNOVATION_LIST_FAILED,
            error
        };
    }

    //**********  DELETE INNOVATION  **********
    static DELETE_INNOVATION_REQUEST = 'DELETE_INNOVATION_REQUEST';
    static DELETE_INNOVATION_SUCCESS = 'DELETE_INNOVATION_SUCCESS';
    static DELETE_INNOVATION_FAILED = 'DELETE_INNOVATION_FAILED';

    static deleteInnovationPromotionRequest() {
        return {
            type: this.DELETE_INNOVATION_REQUEST
        };
    }

    static deleteInnovationPromotionSuccess(data) {
        return {
            type: this.DELETE_INNOVATION_SUCCESS,
            data
        };
    }

    static deleteInnovationPromotionFailed(error) {
        return {
            type: this.DELETE_INNOVATION_FAILED,
            error
        };
    }

    //********** POST INNOVATION VOLUME  **********
    static POST_INNOVATION_VOLUME_REQUEST = 'POST_INNOVATION_VOLUME_REQUEST';
    static POST_INNOVATION_VOLUME_SUCCESS = 'POST_INNOVATION_VOLUME_SUCCESS';
    static POST_INNOVATION_VOLUME_FAILED = 'POST_INNOVATION_VOLUME_FAILED';

    static postInnovationVolumeRequest() {
        return {
            type: this.POST_INNOVATION_VOLUME_REQUEST
        };
    }

    static postInnovationVolumeSuccess(data) {
        return {
            type: this.POST_INNOVATION_VOLUME_SUCCESS,
            data
        };
    }

    static postInnovationVolumeFailed(error) {
        return {
            type: this.POST_INNOVATION_VOLUME_FAILED,
            error
        };
    }

    //********** GET REGION CHANNEL SPLIT **********
    static GET_REGION_CHANNEL_SPLIT_REQUEST = 'GET_REGION_CHANNEL_SPLIT_REQUEST';
    static GET_REGION_CHANNEL_SPLIT_SUCCESS = 'GET_REGION_CHANNEL_SPLIT_SUCCESS';
    static GET_REGION_CHANNEL_SPLIT_FAILED = 'GET_REGION_CHANNEL_SPLIT_FAILED';

    static getRegionChannelSplitRequest() {
        return {
            type: this.GET_REGION_CHANNEL_SPLIT_REQUEST
        };
    }

    static getRegionChannelSplitSuccess(data) {
        return {
            type: this.GET_REGION_CHANNEL_SPLIT_SUCCESS,
            data
        };
    }

    static getRegionChannelSplitFailed(error) {
        return {
            type: this.GET_REGION_CHANNEL_SPLIT_FAILED,
            error
        };
    }

    //********** POST REGION CHANNEL SPLIT **********
    static POST_REGION_CHANNEL_SPLIT_REQUEST = 'POST_REGION_CHANNEL_SPLIT_REQUEST';
    static POST_REGION_CHANNEL_SPLIT_SUCCESS = 'POST_REGION_CHANNEL_SPLIT_SUCCESS';
    static POST_REGION_CHANNEL_SPLIT_FAILED = 'POST_REGION_CHANNEL_SPLIT_FAILED';

    static postRegionChannelSplitRequest() {
        return {
            type: this.POST_REGION_CHANNEL_SPLIT_REQUEST
        };
    }

    static postRegionChannelSplitSuccess(data) {
        return {
            type: this.POST_REGION_CHANNEL_SPLIT_SUCCESS,
            data
        };
    }

    static postRegionChannelSplitFailed(error) {
        return {
            type: this.POST_REGION_CHANNEL_SPLIT_FAILED,
            error
        };
    }
}

export default InnovationActions;
